import { AccountType } from '../account/account';
import { IdIdentifier } from '../common/identifiers';
import { ProgramConfig } from '../program/program';
import { TradingSystem } from '../trading-system';

export enum ProductType {
  Program = 'program',
  AddOn = 'add-on',
  Credit = 'credit',
  General = 'general',
}

export type Product = IdIdentifier & {
  name: string;
  price: number;
  accountType?: AccountType;
  config: ProgramConfig;
  expiryDays?: number;
};

export type ProductMetadata = {
  productName?: string;
  sourceId?: string;
  tradingSystem?: TradingSystem;
};
